import { z } from 'zod';
export const SchnellbuehnenKennungSchema = z.string().refine(id => id.startsWith('sb-') && z.string().uuid().safeParse(id.slice(3)).success,
  { message: 'Schnellbühnen-Kennung muss sb-<uuid> sein.' });
export const SchnellbuehneSchema = z.object({ id: SchnellbuehnenKennungSchema, haus: z.enum(['dev', 'partner']), chatId: z.string().uuid(), parent: z.string().uuid(), nachBuehneId: z.string().min(1), titel: z.string(), am: z.string(), html: z.string() });
export type Schnellbuehne = z.infer<typeof SchnellbuehneSchema>;
export const SCHNELLANTWORT_FEHLT = 'Schnellantwort nicht mehr vorhanden.';
export function istSchnellbuehnenKennung(id: string): boolean {
  return SchnellbuehnenKennungSchema.safeParse(id).success;
}
export function buehnenLeseUrl(id: string): string {
  return istSchnellbuehnenKennung(id)
    ? '/api/guide/coach/schnellchat/buehnen/' + encodeURIComponent(id)
    : '/api/guide/buehnen/' + encodeURIComponent(id);
}
export function buehnenLeseFehlermeldung(id: string, status: number): string {
  return istSchnellbuehnenKennung(id) && status === 404
    ? SCHNELLANTWORT_FEHLT
    : `Bühne nicht erreichbar (HTTP ${status}).`;
}
/** Quick stages are presentations attached to a real stage, never operational tasks. */
export function schnellbuehnenAnsicht<T extends { id: string }>(anker: T, s: Schnellbuehne) {
  return { ...anker, id: s.id, titel: s.titel, schnellbuehne: s,
    entscheidungen: [], vorschlaege: [], nachrichten: [], sitzungen: [], berater: [], unteraufgaben: [],
    abschluss: undefined, rafael_gesehen: undefined, arbeit_laeuft: false, arbeitende_sitzungen: 0,
    berater_still: null, ruhend: null, partner_eigen: false, eigentuemer: 'rafael', vorgaenger: [], kette_an: false,
    zugang: { entscheiden: false, ueberholt: false, grund: 'Schnellbühne' }, stumm_erlaubt: { von: 'rafael', am: s.am, grund: 'Schnellbühne', art: 'dauerprotokoll' as const },
  };
}
export function mitSchnellbuehnen<T extends { id: string }>(reihe: T[], schnell: Schnellbuehne[]): Array<T | ReturnType<typeof schnellbuehnenAnsicht<T>>> {
  return reihe.flatMap(b => [b, ...schnell.filter(s => s.nachBuehneId === b.id).sort((a,b) => a.am.localeCompare(b.am) || a.id.localeCompare(b.id)).map(s => schnellbuehnenAnsicht(b, s))]);
}
